module.exports = __webpack_public_path__ + "static/media/STATREP - New Rochelle.9a0ff2e2.pdf";